export function copyAccessKey() {
  const tgtValue = localStorage.getItem("tgt");
  if (tgtValue) {
    navigator.clipboard.writeText(tgtValue);
    alert("Access key copied to clipboard");
  } else {
    alert("No Access key found!");
  }
}
